import { Center, Text, Box } from "@chakra-ui/react";
import SectionTitle from "../SectionTitle";
import EmailModal from "./Email";

const SubscribeCard = () => {
  return (
    <Center flexDir="column" alignItems={{ base: "flex-start", md: "center" }}>
      <SectionTitle title="Stay updated with Kelp" />
      <Text
        color="textSecondary"
        fontWeight="500"
        fontSize={{ base: "10px", md: "16px" }}
        lineHeight={{ base: "100%", md: "22px" }}
        mt="16px"
      >
        Join a community of 500+ and be the first to know about exclusive
        rewards.
      </Text>
      <Box mt={{ base: "2rem", md: "4rem" }}>
        <EmailModal />
      </Box>
    </Center>
  );
};

export default SubscribeCard;
